export function isBottomThresholdReached(document: Document, offset?: number): boolean {
    const offsetBottom = offset ? offset : 0;
    const thresholdY = document.documentElement.scrollHeight - offsetBottom;
    return isThresholdYReached(document, thresholdY);
}

export function isElementInViewport(
    document: Document,
    elementTop: number,
    elementHeight: number,
): boolean {
    const scrollTop = Math.max(document.documentElement.scrollTop, document.body.scrollTop);
    const thresholdY = scrollTop + elementTop + elementHeight;
    return isThresholdYReached(document, thresholdY);
}

function isThresholdYReached(document: Document, thresholdY: number): boolean {
    const viewport = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    const scrollTop = Math.max(document.documentElement.scrollTop, document.body.scrollTop);
    const scrollY = viewport + scrollTop;
    return scrollY >= thresholdY;
}

export function getElementPositionY(document: Document, elementTop: number) {
    const scrollTop = Math.max(document.documentElement.scrollTop, document.body.scrollTop);
    return scrollTop + elementTop;
}
